<template>
  <div class="A4">
    <div class="row my-4">
      <h2 class="col-12">{{ transferOrder }}</h2>
    </div>
    <div class="row my-4">
      <div class="col-4">
        <strong>{{ supplier }}</strong>
        <div>{{ print.transferFrom }}</div>
      </div>
      <div class="col-4">
        <strong>{{ shipTo }}</strong>
        <div>{{ print.transferTo }}</div>
      </div>
      <div class="col-4 row">
        <div class="col-6" style="text-align: right">
          <strong>{{ toNo }}:</strong><br/>
          <strong>{{ date }}:</strong>
        </div>
        <div class="col-6" style="text-align: left">
          <div>{{ print.givenId }}</div>
          <div>{{ transferDate }}</div>
        </div>
      </div>
    </div>
    <div class="row my-5">
      <div class="col-12">
        <table class="vgt-table condensed striped">
          <thead>
            <tr v-if="featureFlags.isMaKuang">
              <th>Item Code<br/>物品编号</th>
              <th>Item Name<br/>物品名称</th>
              <th style="width: 20%">TO Quantity<br/>TO数量</th>
              <th style="width: 16%">Batch Number<br/>批号</th>
              <th>Expiry<br/>到期日</th>
            </tr>
            <tr v-else>
              <th>{{ $t("inventoryTransferPrint.itemCode") }}</th>
              <th>{{ $t("inventoryTransferPrint.itemName") }}</th>
              <th style="width: 20%">{{ $t("inventoryTransferPrint.toQuantity") }}</th>
              <th style="width: 16%">{{ $t("inventoryTransferPrint.batchNumber") }}</th>
              <th>{{ $t("inventoryTransferPrint.expiryDate") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, k) in this.transferItem" :key="k">
              <td>
                <span>{{ row.givenId }}</span>
              </td>
              <td>
                <span>{{ row.name }}</span>
              </td>
              <td>
                <span>{{ row.quantity }}</span>
              </td>
              <td>
                <span>{{ row.number }}</span>
              </td>
              <td>
                <span>{{ formatdate(row.expiry) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br/><br/>
    <div class="row my-5 justify-content-center text-center">
      <div class="col-4">
        {{ approveBy }}: _________________
      </div>
      <div class="col-4">
        {{ deliveryBy }}: _________________
      </div>
      <div class="col-4">
        {{ receiveBy }}: _________________
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from "moment";

export default {
  name: 'InventoryTransfer',
  computed: {
    ...mapState('inventoryTransfer', ['print']),
    ...mapGetters('config', ['featureFlags']),
    transferItem() {
      return this.print.transferItems.sort((itemA, itemB) => {
        if (isNaN(itemA.givenId[0]) && !isNaN(itemB.givenId[0])) {
          return -1;
        }
        else if (!isNaN(itemA.givenId[0]) && isNaN(itemB.givenId[0])) {
          return 1;
        }
        else {
          const givenIdComparison = itemA.givenId.localeCompare(itemB.givenId);
          if (givenIdComparison !== 0){
            return givenIdComparison;
          }
          else {
            return itemA.originalIndex - itemB.originalIndex;
          }
        }
      })
    },
    transferDate() {
      return this.print.transferDate? moment(this.print.transferDate).format('DD/MM/YYYY') : "";
    },
    transferOrder() {
      if (this.featureFlags.isMaKuang){
        return "Transfer Order"
      }

      return this.$t("inventoryTransferPrint.transferOrder");
    },
    supplier() {
      if (this.featureFlags.isMaKuang){
        return "Supplier"
      }

      return this.$t("inventoryTransferPrint.supplier");
    },
    shipTo() {
      if (this.featureFlags.isMaKuang){
        return "Ship To"
      }

      return this.$t("inventoryTransferPrint.shipTo");
    },
    toNo() {
      if (this.featureFlags.isMaKuang){
        return "TO No"
      }

      return this.$t("inventoryTransferPrint.toNo");
    },
    date() {
      if (this.featureFlags.isMaKuang){
        return "Date"
      }

      return this.$t("inventoryTransferPrint.date");
    },
    itemCode() {
      if (this.featureFlags.isMaKuang){
        return "物品编号"
      }

      return this.$t("inventoryTransferPrint.itemCode");
    },
    itemName() {
      if (this.featureFlags.isMaKuang){
        return "Item Name<br/>物品名称"
      }

      return this.$t("inventoryTransferPrint.itemName");
    },
    toQuantity() {
      if (this.featureFlags.isMaKuang){
        return "TO Quantity<br/>TO数量"
      }

      return this.$t("inventoryTransferPrint.toQuantity");
    },
    batchNumber() {
      if (this.featureFlags.isMaKuang){
        return "Batch Number<br/>批号"
      }

      return this.$t("inventoryTransferPrint.batchNumber");
    },
    expiryDate() {
      if (this.featureFlags.isMaKuang){
        return "Expiry<br/>到期日"
      }

      return this.$t("inventoryTransferPrint.expiryDate");
    },
    amount() {
      if (this.featureFlags.isMaKuang){
        return "Amount<br/>金额"
      }

      return this.$t("inventoryTransferPrint.amount");
    },
    approveBy() {
      if (this.featureFlags.isMaKuang){
        return "Approve By"
      }

      return this.$t("inventoryTransferPrint.approveBy");
    },
    deliveryBy() {
      if (this.featureFlags.isMaKuang){
        return "Delivery By"
      }

      return this.$t("inventoryTransferPrint.deliveryBy");
    },
    receiveBy() {
      if (this.featureFlags.isMaKuang){
        return "Receive By"
      }

      return this.$t("inventoryTransferPrint.receiveBy");
    }
  },
  methods: {
    formatdate(val) {
      let format = 'DD/MM/YYYY';
      if (this.$store.state.config.inventory.expiryFormatConfig === 'YYYY-MM') {
        format = 'MM/YYYY';
      }
      return val? moment(val).format(format) : "";
    }
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 2000);
  }
}

</script>

<style scoped src="../../assets/paper.css"></style>
<style scoped>
  td {
    padding: 0.75em 1.5em 0.75em 0.75em !important;
  }
</style>
